export class DataHolder {
  static set currentUserId(value) {
    this.getDataHolder().currentUserId = value;
  }
  static get currentUserId() {
    return this.getDataHolder().currentUserId ?? undefined;
  }

  static getDataHolder() {
    if (
      !('__DataHolder__' in globalThis) ||
      globalThis.__DataHolder__ == null
    ) {
      globalThis.__DataHolder__ = {};
    }

    return globalThis.__DataHolder__;
  }
}
